export default __webpack_public_path__ + "static/media/1.ab180534.svg";